export const toNullableText = (value) => {
  const normalized = String(value ?? '').trim();
  return normalized === '' ? '' : normalized;
};

export const resolveText = (value, fallback = '') => {
  const text = String(value ?? '').trim();
  return text !== '' ? text : fallback;
};

export const toComparableText = (value) => String(value ?? '').trim().toLowerCase();

export const toComparableSearchText = (value) => String(value ?? '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim();

export const buildComparableHaystack = (values = []) => {
  const rows = Array.isArray(values) ? values : [];

  return rows
    .map((value) => toComparableSearchText(value))
    .join(' ');
};

export const valueOrDash = (value, fallback = '-') => {
  const normalized = String(value ?? '').trim();
  return normalized === '' ? fallback : normalized;
};

export const buildInitials = (name, { fallback = 'CL', maxParts = 2 } = {}) => {
  const parts = String(name ?? '')
    .split(' ')
    .map((part) => part.trim())
    .filter(Boolean)
    .slice(0, maxParts);

  if (parts.length === 0) {
    return fallback;
  }

  return parts.map((part) => part.charAt(0).toUpperCase()).join('');
};

export const formatCodeName = (code, name, label) => {
  const normalizedLabel = String(label || '').trim();
  if (normalizedLabel !== '') {
    return normalizedLabel;
  }

  const normalizedCode = String(code || '').trim();
  const normalizedName = String(name || '').trim();

  if (normalizedCode !== '' && normalizedName !== '') {
    return `${normalizedCode} - ${normalizedName}`;
  }

  return normalizedCode || normalizedName;
};

export const truncateText = (value, maxLength = 70) => {
  const text = String(value ?? '').trim();
  const limit = Number(maxLength || 0);

  if (!Number.isFinite(limit) || limit <= 0 || text.length <= limit) {
    return text;
  }

  return `${text.slice(0, limit).trim()}...`;
};
